import React, { useState } from "react";
import "./index.scss";
import { Col, Row, Typography, Select, Pagination } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import DownIcon from "@components/svg/DownIcon";
import AvatarDefault from "@assets/images/ava.svg";
import { useQuery } from "react-query";
import {
  getBidProduct,
  getHistoryBid,
  getHistoryBidAll,
} from "dataLayer/product";
import { useLocation, useParams } from "react-router-dom";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";
import PhoneNumber from "@components/PhoneNumber";
import AuctionTime from "@components/AuctionTime";
import { currentDate } from "@utils/utils";

const { Title, Text } = Typography;
const { Option } = Select;

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return "";
  }
  if (type === "next") {
    return "";
  }
  return originalElement;
}

const RightMenu = ({ type = "default", dataReferral, dataGift, ...props }) => {
  const { t } = useTranslation();
  const { cp_id } = useParams();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("desc");

  const { data: products } = useQuery(getBidProduct());

  let products_id = [cp_id];
  if (
    location.pathname === PATHS.BID_PAGE ||
    location.pathname === PATHS.BID2_PAGE ||
    location.pathname === PATHS.HOME_PAGE
  ) {
    products_id = products?.map((product) => {
      if (
        product?.status === 1 &&
        new Date(product?.start_time).getTime() < currentDate
      ) {
        return product?.cp_id;
      } else return null;
    });
  }
  if (products_id?.every((element) => element === null)) {
    products_id = null;
  }

  const { data } = useQuery(getHistoryBid(products_id, page, sort));

  const PAGE_SIZE_DATAALL = 10;
  const { data: dataAll } = useQuery(
    getHistoryBidAll(page, sort, PAGE_SIZE_DATAALL)
  );

  const onChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleChangeSort = (nextSort) => {
    setSort(nextSort);
  };
  return (
    <div className="right-menu-wrapper">
      <div className="right-menu">
        <div className="right-menu-filter">
          <Row justify="space-between">
            <Col>
              <Title level={2} className="page-title">
                {type === "AccountReferral" ? t("account.Referral_page.history") : type === "AccountGift" ? t("account.gift_page.history") : t("bid.history")}
              </Title>
            </Col>
            <Col>
              <Select
                className="right-filter"
                suffixIcon={<DownIcon style={{ fontSize: "10px" }} />}
                bordered={false}
                onChange={handleChangeSort}
                value={sort}
                style={{ width: 140 }}>
                <Option value="desc" title="">
                  {t("sort.lastest")}
                </Option>
                <Option value="asc" title="">
                  {t("sort.oldest")}
                </Option>
              </Select>
            </Col>
          </Row>
        </div>
        <div className="right-menu-list">
          <Scrollbars>
            <Row gutter={[0, { xs: 35, md: 35, lg: 30, xl: 30, xxl: 35 }]}>
              {products_id != null
                ? (type === "AccountReferral" ? dataReferral : type === "AccountGift" ? dataGift : data)?.data?.map((history, index) => (
                  <Col xs={24} lg={12} xl={24} key={index}>
                    <div className="list-item">
                      <Row
                        gutter={[0, 0]}
                        justify="space-between"
                        align="middle">
                        <Col xs={15} md={15}>
                          <div className="list-item-wrapper">
                            <div>
                              <Text
                                href=""
                                className="list-item-image"
                                style={{
                                  backgroundImage: `url(${history?.image || AvatarDefault
                                    })`,
                                }}
                              />
                            </div>
                            <div className="list-item-user">
                              <Text href="" className="list-item-name">
                                {history?.name || history?.isdn}
                              </Text>
                              <PhoneNumber
                                value={history?.isdn}
                                className="list-item-phone"
                              />
                              <AuctionTime value={history?.auction_time} />
                            </div>
                          </div>
                        </Col>
                        <Col xs={9} md={9}>
                          <Title level={5} className="list-item-label">
                            {type === "AccountReferral" || type === "AccountGift" ? <div style={{ color: "#FF4921" }}>{history?.status}</div> : t("bid.price")}
                          </Title>
                          {type === "AccountReferral" || type === "AccountGift" ? null : <Text className="list-item-price">
                            {history?.price !== "***"
                              ? `${t("currency_sign")} ${history?.price}`
                              : "***"}
                          </Text>}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                )
                )
                : dataAll?.data?.map((history, index) => (
                  <Col xs={24} lg={12} xl={24} key={index}>
                    <div className="list-item">
                      <Row
                        gutter={[0, 0]}
                        justify="space-between"
                        align="middle">
                        <Col xs={15} md={15}>
                          <div className="list-item-wrapper">
                            <div>
                              <Text
                                href=""
                                className="list-item-image"
                                style={{
                                  backgroundImage: `url(${history?.image || AvatarDefault
                                    })`,
                                }}
                              />
                            </div>
                            <div className="list-item-user">
                              <Text href="" className="list-item-name">
                                {history?.name || history?.isdn}
                              </Text>
                              <PhoneNumber
                                value={history?.isdn}
                                className="list-item-phone"
                              />
                              <AuctionTime value={history?.auction_time} />
                            </div>
                          </div>
                        </Col>
                        <Col xs={9} md={9}>
                          <Title level={5} className="list-item-label">
                            {t("bid.price")}
                          </Title>
                          <Text className="list-item-price">
                            {history?.price !== "***"
                              ? `${t("currency_sign")} ${history?.price}`
                              : "***"}
                          </Text>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
            </Row>
          </Scrollbars>
        </div>
        {products_id != null ? (
          <Pagination
            className="right-pagination"
            responsive={true}
            hideOnSinglePage={true}
            showQuickJumper={false}
            showSizeChanger={false}
            showTitle={false}
            showLessItems={true}
            itemRender={itemRender}
            size="small"
            current={page}
            pageSize={((type === "AccountReferral" ? dataReferral : type === "AccountGift" ? dataGift : data))?.pageSize || 0}
            total={((type === "AccountReferral" ? dataReferral : type === "AccountGift" ? dataGift : data))?.total || 0}
            onChange={onChange}
          />
        ) : (
          <Pagination
            className="right-pagination"
            responsive={true}
            hideOnSinglePage={true}
            showQuickJumper={false}
            showSizeChanger={false}
            showTitle={false}
            showLessItems={true}
            itemRender={itemRender}
            size="small"
            current={page}
            pageSize={PAGE_SIZE_DATAALL}
            total={dataAll?.total || 0}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
};

export default RightMenu;
